<template>
	<div class="orders-product">
		<div
			class="title-products font-size"
			:style="`color:${globalColors.primary}`"
		>{{orderState}} - Nro de Orden {{orderNumber}}</div>
		<div 
			class="d-flex space-around"
			:style="`border-bottom: 0.1rem solid ${globalColors.primary};`"
		>
			<div>
				<p class="text-bold font-size">Precio Total: <span class="text-regular">PEN {{orderTotal}}</span></p>
			</div>
			<div>
				<p class="text-bold font-size">Fecha de la Orden: <span class="text-regular">{{orderDate}}</span></p>
			</div>
			<div>
				<p class="text-bold font-size">Estado: <span class="text-regular">{{orderPaymentStateName}}</span></p>
			</div>
		</div>
		<p class="text-bold font-size">Direccion: <span class="text-regular">{{orderWarehouseAddress}}</span></p>
		<transition-group name="fade-lateral" tag="div" class="relative">
			<div v-if="currentProductIsEmpty" :key="1" class="absolute w-100">
				<div class="table-responsive">
					<table-detail-product
						:rows="rows"
						:order-state="orderStateCode"
						@rating="rating"
					/>
				</div>
				<div class="table-mobile">
					<table-detail-product-mobile 
						:rows="rows"
						:order-state="orderStateCode"
						@rating="rating"
					/>
				</div>
			</div>
			<div v-else class="product-rating-container absolute w-100" :key="2">
				<section class="product-rating">
					<img
						class="product-rating-img"
						:src="currentProduct.productImage"
						alt="imagen del producto"
					>
					<div>
						<h3 class="product-rating-name">{{currentProduct.productName}}</h3>
						<p>{{currentProduct.description}}</p>
						<span class="product-rating-code">{{currentProduct.productCode}}</span>
					</div>
				</section>
				<section>
					<FormOpinion
						:id="currentProductId"
						@cancel-rating="cancelRating"
					/>
				</section>
			</div>
		</transition-group>
	</div>
</template>
<script>
import tableDetailProduct from '@/components/profile/table-detail-product';
import tableDetailProductMobile from '@/components/profile/table-detail-product-mobile';
import lib from '@/helpers/lib';

const { getDeeper, isEmpty } = lib;

function orderState() {
	return getDeeper('orderState.name')(this.order);
}

function orderStateCode() {
	return getDeeper('orderState.code')(this.order);
}

function orderPaymentStateName() {
	return getDeeper('paymentStateName')(this.order);
}

function orderNumber() {
	return getDeeper('number')(this.order);
}

function orderTotal() {
	return getDeeper('total')(this.order);
}

function orderDate() {
	const date = getDeeper('createdAt')(this.order);
	const day = new Date(date).getDay();
	const month = new Date(date).getMonth() + 1;
	const year = new Date(date).getFullYear();
	return `${day}-${month}-${year}`;
}

function orderWarehouseAddress() {
	return getDeeper('warehouseAddress')(this.order);
}

function rating(product) {
	this.currentProduct = product;
	this.currentProductId = product.id;
}

function currentProductIsEmpty() {
	return isEmpty(this.currentProduct);
}

function cancelRating() {
	this.currentProduct = {};
	this.currentProductId = 0;
}

function data() {
	return {
		currentProduct: {},
		currentProductId: 0,
	};
}

export default {
	name: 'orders-products',
	components: {
		FormOpinion: () => import('@/components/detail/formOpinion'),
		tableDetailProductMobile,
		tableDetailProduct,
	},
	computed: {
		currentProductIsEmpty,
		orderDate,
		orderNumber,
		orderState,
		orderStateCode,
		orderTotal,
		orderWarehouseAddress,
		orderPaymentStateName,
	},
	data,
	methods: {
		cancelRating,
		rating,
	},
	props: {
		rows: {
			type: Array,
			default: () => [],
		},
		order: {
			default: () => {},
			type: Object,
		},
	},
};
</script>

<style lang="scss" scoped>

.title-products {
	font-weight: bold;
}

.font-size {
	font-size: size(maxsmall);
}

.text-bold {
	font-weight: bold;
}

.text-regular {
	font-weight: normal;
}

.orders-product {
	padding: 2rem;
}

.table-mobile {
	display: none;

	@media screen and (max-width: 780px) {
		display: block;
	}
}

@media screen and (max-width: 780px) {
	.table-responsive {
		display: none;
	}
}

.product-rating {
	align-items: center;
	border-bottom: 0.2rem solid color(textGrey);
	border-top: 0.2rem solid color(textGrey);
	display: grid;
	font-size: size(normal);
	grid-template-columns: 0.5fr 2fr;
	margin-bottom: 2rem;
	padding: 1rem 2rem;

	&-code {
		color: color(text-grey-max);
	}

	&-name {
		margin: 0;
	}

	&-img {
		width: 12rem;
	}
}

</style>



// WEBPACK FOOTER //
// orders-products.vue?d046510e